const CANCEL_PAYMENT = {
  dataAid: "cancelPayment",
  title: {
    text: "Cancel payment?",
  },
  subtitle: {
    text: "If any amount is debited from your account, it will be credited back within 3-5 working days",
  },
  primaryButton: {
    title: "CANCEL",
  },
  secondaryButton: {
    title: "DISMISS",
  },
};

const VERIFY_PAYMENT_STATUS = {
  screenDataAid: "paymentDetails",
  headerData: {
    dataAid: "paymentDetails",
    title: {
      text: "Payment details",
    },
    subtitle: {
      text: "Payable amount:",
    },
  },
  paymentStatus: {
    text: "Verifying payment status",
    dataAid: "title",
  },
  timer: {
    subtext1: `Payment request will expire in`,
    subtext2: `minutes`,
    subtext3: `seconds`,
    dataAid: "timer",
  },
  upiLink: {
    text: "Open the UPI app linked with",
    dataAid: "subtitle",
  },
  upiId: {
    text: "UPI ID:",
  },
  cta: {
    text: "Cancel payment",
    dataAid: "primary",
  },
  waitingInfo: {
    text: "Payment is taking longer than usual. If you have not made the payment, you can cancel it",
    dataAid: "note",
  },
  cancelPayment: CANCEL_PAYMENT,
};

export default VERIFY_PAYMENT_STATUS;
